// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@-webkit-keyframes skeleton {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
@keyframes skeleton {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
.skltn-row {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
          justify-content: space-between;
  margin: 24px 20px 16px;
}
.skltn-item {
  height: 24px;
  border-radius: 3px;
  background: linear-gradient(91deg, rgba(0, 0, 0, 0.06) 25%, rgba(0, 0, 0, 0.15) 37%, rgba(0, 0, 0, 0.06) 63%);
  background-size: 400% 100%;
  -webkit-animation: skeleton 1s ease infinite;
          animation: skeleton 1s ease infinite;
}
.skltn-item.circle {
  border-radius: 50%;
  width: 32px!important;
  height: 32px!important;
}
.ynf-skltn-wrap {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 100;
  background: #fff;
}
.skltn-mob {
  margin: 5.5vh 4vw 0;
}
.skltn-mob .skltn-row {
  margin: 0;
  -webkit-align-items: center;
          align-items: center;
}
.skltn-mob .skltn-summary {
  margin-bottom: 1vh;
  padding-bottom: 2vh;
  border-bottom: 1vh solid #ececec;
  margin-left: -4vw;
  margin-right: -4vw;
  padding-left: 4vw;
  padding-right: 4vw;
}
.skltn-mob .skltn-footer {
  margin-top: 6vh;
  border-top: 1px solid #e6e6e6;
  margin-left: -4vw;
  margin-right: -4vw;
  padding-left: 4vw;
  padding-right: 4vw;
  padding-top: 1vh;
}
.skltn-mob .skltn-header {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
          justify-content: space-between;
}
.skltn-mob .skltn-title {
  height: 2.5vh;
}
.skltn-mob .skltn-txt {
  height: 1.5vh;
}
.skltn-mob .skltn-summary {
  margin-top: 2vh;
}
`, "",{"version":3,"sources":["webpack://./src/runtime/views/skeleton.less"],"names":[],"mappings":"AAAA;EACE;IACE,6BAAA;EACF;EACA;IACE,0BAAA;EACF;AACF;AAPA;EACE;IACE,6BAAA;EACF;EACA;IACE,0BAAA;EACF;AACF;AACA;EACE,qBAAA;EAAA,aAAA;EACA,sCAAA;UAAA,8BAAA;EACA,sBAAA;AACF;AAEA;EACE,YAAA;EACA,kBAAA;EACA,6GAAA;EACA,0BAAA;EACA,4CAAA;UAAA,oCAAA;AAAF;AACE;EACE,kBAAA;EACA,qBAAA;EACA,sBAAA;AACJ;AAEA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AAAF;AAEA;EACE,mBAAA;AAAF;AADA;EAGI,SAAA;EACA,2BAAA;UAAA,mBAAA;AACJ;AALA;EAOI,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AACJ;AAdA;EAgBI,eAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AACJ;AAvBA;EAyBI,qBAAA;EAAA,aAAA;EACA,sCAAA;UAAA,8BAAA;AACJ;AA3BA;EA6BI,aAAA;AACJ;AA9BA;EAgCI,aAAA;AACJ;AAjCA;EAmCI,eAAA;AACJ","sourcesContent":["@keyframes skeleton {\n  0% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0 50%;\n  }\n}\n.skltn-row {\n  display: flex;\n  justify-content: space-between;\n  margin: 24px 20px 16px;\n}\n\n.skltn-item {\n  height: 24px;\n  border-radius: 3px;\n  background: linear-gradient(91deg, rgba(0, 0, 0, 0.06) 25%, rgba(0, 0, 0, 0.15) 37%, rgba(0, 0, 0, 0.06) 63%);\n  background-size: 400% 100%;\n  animation: skeleton 1s ease infinite;\n  &.circle {\n    border-radius: 50%;\n    width: 32px!important;\n    height: 32px!important;\n  }\n}\n.ynf-skltn-wrap{\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  overflow: hidden;\n  z-index: 100;\n  background: #fff;\n}\n.skltn-mob{\n  margin: 5.5vh 4vw 0;\n  .skltn-row {\n    margin: 0;\n    align-items: center;\n  }\n  .skltn-summary{\n    margin-bottom: 1vh;\n    padding-bottom: 2vh;\n    border-bottom: 1vh solid #ececec;\n    margin-left: -4vw;\n    margin-right: -4vw;\n    padding-left: 4vw;\n    padding-right: 4vw;\n  }\n  .skltn-footer{\n    margin-top: 6vh;\n    border-top: 1px solid #e6e6e6;\n    margin-left: -4vw;\n    margin-right: -4vw;\n    padding-left: 4vw;\n    padding-right: 4vw;\n    padding-top: 1vh;\n  }\n  .skltn-header{\n    display: flex;\n    justify-content: space-between;\n  }\n  .skltn-title{\n    height: 2.5vh;\n  }\n  .skltn-txt{\n    height: 1.5vh;\n  }\n  .skltn-summary{\n    margin-top: 2vh;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
